import axios from 'axios';
import NProgress from 'nprogress';
// import Echo from '@/helpers/echo';

// import stringify  from '@/helpers/stringify';

const Http = axios.create({
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json',
  },
  // transformResponse: [
  //   data => {
  //     console.log(data);
  //     return data;
  //   }
  // ]
  // paramsSerializer(params) {
  //   if (typeof params.stringify === 'function')
  //     return params.stringify();

  //   return stringify(params);
  // }

  // validateStatus(status) {
  //   console.log(status);
  //   return status < 300;
  // }
});

// Http.interceptors.request.use(config => {
//   if (Echo.socketId())
//     config.headers['X-Socket-ID'] = Echo.socketId();
//   return config;
// });

Http.interceptors.request.use(config => {
  NProgress.start();
  return config;
}, error => {
  NProgress.done();
  throw error;
});

Http.interceptors.response.use(response => {
  NProgress.done();
  return response.data;
}, error => {
  NProgress.done();
  throw error;
});

export default Http;
